import { Phone, MoonStar } from "lucide-react";
import { Reveal } from "./Reveal";
import { SITE, TEL_HREF } from "@/siteConfig";

const NIGHT_IMAGE = {
  url: "/images/night.webp",
  alt: "Roma di notte, cancelli e architetture illuminate",
};

export const NightService = () => (
  <section
    id="notturno"
    data-testid="night-service-section"
    className="relative scroll-mt-24 overflow-hidden py-24 sm:py-32"
  >
    <img
      src={NIGHT_IMAGE.url}
      alt={NIGHT_IMAGE.alt}
      loading="lazy"
      className="absolute inset-0 h-full w-full object-cover opacity-25"
    />
    <div className="absolute inset-0 bg-gradient-to-b from-[#0A0D12] via-[#0A0D12]/80 to-[#0A0D12]" />

    <div className="relative mx-auto max-w-4xl px-4 text-center sm:px-6 lg:px-8">
      <Reveal>
        <div className="mx-auto mb-6 flex h-14 w-14 items-center justify-center rounded-2xl border border-amber-400/30 bg-amber-400/10 text-amber-400">
          <MoonStar className="h-7 w-7" />
        </div>
        <p className="font-tech text-xs uppercase tracking-[0.3em] text-amber-400 font-semibold">
          Servizio serale e notturno
        </p>
        <h2 className="mt-4 font-display text-2xl sm:text-3xl lg:text-4xl font-bold tracking-tight text-zinc-50">
          Problema durante la notte?
        </h2>
        <p className="mx-auto mt-5 max-w-2xl text-base sm:text-lg text-zinc-300 leading-relaxed">
          FIX ROMA H24 è pensato per gestire richieste di pronto intervento
          anche nelle ore serali e notturne a Roma e provincia.
        </p>
        <a
          href={TEL_HREF}
          data-testid="night-call-now-button"
          className="mt-8 inline-flex items-center gap-3 rounded-full bg-amber-400 px-9 py-4 text-base font-extrabold uppercase tracking-wide text-zinc-950 transition-all hover:bg-amber-300 hover:shadow-[0_0_44px_rgba(245,158,11,0.5)] active:scale-[0.98]"
        >
          <Phone className="h-5 w-5" />
          Chiama ora · {SITE.phoneDisplay}
        </a>
        <p className="mt-6">
          <a
            href="/pronto-intervento-notturno-roma"
            data-testid="night-page-link"
            className="text-sm font-semibold text-amber-400/90 underline-offset-4 transition-colors hover:text-amber-300 hover:underline"
          >
            Scopri il pronto intervento notturno a Roma →
          </a>
        </p>
      </Reveal>
    </div>
  </section>
);
